import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import Form from "react-bootstrap/Form";
import { CopyIcon, EditIcon, TrashIcon } from "../../components/SVGIcon";

export const NotesSchema = {
  name: "Notes",
  tag: "Notes",
  fields: [
    {
      type: "text",
      label:
        "This section can be used to add any additional notes or comments related to the report.",
      placeholder:
        "This section can be used to add any additional notes or comments related to the report.",
      selectedDropdownValue: "",
      value: "",
      isDigital: true,
    },
  ],
};

const NotesSection = ({
  markSectionEditing,
  updateSection,
  isCreateReportRoute,
  section,
  index,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [isEditModeOn, setIsEditModeOn] = useState(false);
  const [localFields, setLocalFields] = useState([]);
  const [localSectionName, setLocalSectionName] = useState("");

  useEffect(() => {
    if (!section?.id) return;
    markSectionEditing(section.id, isEditModeOn);
  }, [isEditModeOn, section?.id, markSectionEditing]);

  useEffect(() => {
    if (isEditModeOn) return;

    setLocalFields(structuredClone(section?.fields ?? []));
    setLocalSectionName(section?.name ?? "");
  }, [section?.id]);


  useEffect(() => {
    setIsEditModeOn(false);
  }, []);

  const handleDeleteSection = () => {
    updateSection(section.id, null);
    setShowModal(false);
  };

  const handleChange = (row, value) => {
    setLocalFields(prev =>
      prev.map((f, i) =>
        i === row ? { ...f, placeholder: value } : f
      )
    );
  };


  const handleSave = () => {
    updateSection(section.id, prev => ({
      ...prev,
      name: localSectionName,
      fields: localFields,
    }));
    setIsEditModeOn(false);
  };

  const handleCancel = () => {
    setIsEditModeOn(false);
  };


  return (
    <>
      <div className="d-flex align-items-center justify-content-between gap-3 p-3 border-bottom">
        {/* <h2 className="fs-20 fw-semibold mb-0">Notes</h2> */}
        {isEditModeOn ? (
          <Form.Control
            type="text"
            value={localSectionName}
            onChange={(e) => setLocalSectionName(e.target.value)}
            className="fs-20 fw-semibold mb-0 border-0 bg-transparent"
            style={{ maxWidth: "400px" }}
          />
        ) : (
          <Form.Control
            type="text"
            readOnly
            value={section?.name || ""}
            // onChange={(e) => setLocalSectionName(e.target.value)}
            // onChange={(e) => handleSectionNameChange(section.id, e.target.value)}
            className="fs-20 fw-semibold mb-0 border-0 bg-transparent"
            style={{ maxWidth: "400px" }}
          />
        )}
        <div className="d-flex align-items-center gap-1">
          <Button
            variant="icon"
            className="btn-md text-blue-600"
            onClick={(e) => setIsEditModeOn(true)}
          >
            <EditIcon />
          </Button>
          {!isCreateReportRoute && <Button
            variant="icon"
            className="btn-md text-red-600"
            onClick={() => {
              setShowModal(true);
            }}
          >
            <TrashIcon />
          </Button>}
        </div>
      </div>
      <div className="p-3">
        {localFields?.map((element, row) => {
          return (
            <textarea
              type="text"
              readOnly={!isEditModeOn}
              id={`notes-${index}-${row}`}
              className="form-control"
              placeholder={element.label}
              aria-label={element.label}
              // defaultValue="Company Details"
              value={element.placeholder}
              onChange={(e) => handleChange(row, e.target.value)}
            />
          );
        })}
      </div>

      {isEditModeOn && (
        <div className="p-3 border-top">
          <Row className="gy-2 gy-sm-0">
            <Col md="8" className="d-flex align-items-center gap-2">
              <Button variant="primary" className="btn-md" onClick={handleSave}>
                Save & Update
              </Button>
              <Button
                variant="outline-secondary"
                className="btn-md"
                onClick={handleCancel}
              >
                Cancel
              </Button>
            </Col>
            {!isCreateReportRoute && (
              <Col md="4" className="text-sm-end">
                <Button
                  variant="danger-light"
                  className="btn-md"
                  onClick={() => setShowModal(true)}
                >
                  Delete Section
                </Button>
              </Col>
            )}
          </Row>
        </div>
      )}


      <Modal
        className="info-modal"
        show={!!showModal}
        onHide={() => setShowModal(false)}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <div className="text-center">
            <Image src="/images/delete-badge-red.svg" alt="Delete Badge" />
            <h2 className="fs-2 fw-semibold text-gray-700 mt-5 mb-2">
              Are you sure you want to delete this section?
            </h2>

            <div className="d-flex align-items-center gap-3">
              <Button
                variant="primary"
                className="btn w-100 mt-5"
                onClick={handleDeleteSection}
              >
                Yes, Delete It!
              </Button>
              <Button
                variant="gray"
                className="btn w-100 mt-5"
                onClick={() => setShowModal(false)}
              >
                No, Not Yet
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default NotesSection;
